const themeList: string[] = ["light", "dark"];

export default themeList;
